"use client";

import React, { HTMLAttributes } from "react";

import { useSelector } from "@/redux/hooks";
import { getNotificationCount } from "@/redux/selectors/header";

export const NotificationDot: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className = "",
  ...props
}) => {
  const unreadCount = useSelector(getNotificationCount);

  if (!unreadCount || Number(unreadCount) === 0) {
    return null;
  }

  return (
    <div
      className={`pointer-events-none rounded-full bg-white h-3 w-3 flex items-center justify-center ${className}`}
      {...props}
    >
      <div className="bg-error rounded-full h-2 w-2" />
    </div>
  );
};

export const NotificationTag: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className = "",
  ...props
}) => {
  const unreadCount = useSelector(getNotificationCount);

  if (!unreadCount || Number(unreadCount) === 0) {
    return null;
  }

  return (
    <div
      className={`bg-error rounded-full text-white py-1 px-2 text-xs w-fit ${className}`}
      {...props}
    >
      {Number(unreadCount) > 9 ? "9+" : unreadCount} new
    </div>
  );
};
